import { t } from "i18next";
import { toast } from "react-hot-toast";
import { Modal } from "ui";

import { useDeleteUsageGuideFaqItem } from "../../../apis";
import { DeleteUsageGuideFaqItemModalProps } from "./DeleteUsageGuideFaqItemModal.types";

import styles from "./DeleteUsageGuideFaqItemModal.module.scss";

const DeleteUsageGuideFaqItemModal = ({
  isOpen,
  id,
  onClose
}: DeleteUsageGuideFaqItemModalProps) => {
  const deleteFaqItem = useDeleteUsageGuideFaqItem({
    onSuccess: () => {
      onClose();
      toast.success(t("Question has been deleted successfully"));
    }
  });

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title="Delete Question"
      isLoading={deleteFaqItem.isLoading}
      okText="Delete"
      onOk={() => deleteFaqItem.mutate(id)}
      contentClassName={styles.modal}
      onClose={onClose}
    >
      <p className={styles.modal_text}>
        {t("Are you sure you want to delete this question?")}
      </p>
    </Modal>
  );
};

export default DeleteUsageGuideFaqItemModal;
